import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c7137a1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6c7137a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7137a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7137a1')) {
      api.createRecord('6c7137a1', component.options)
    } else {
      api.reload('6c7137a1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c7137a1&scoped=true&", function () {
      api.rerender('6c7137a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/components/crash-bet/index.vue"
export default component.exports